/**
 * Client-side plugin to add data-nosnippet attribute to OneTrust cookie banner
 * This prevents Google from using the cookie banner text in search result snippets
 */

export default defineNuxtPlugin(() => {
  if (process.server) {
    return
  }

  const addNoSnippetToBanner = (): boolean => {
    const banner = document.getElementById("onetrust-banner-sdk")

    if (banner) {
      banner.setAttribute("data-nosnippet", "")
      banner.setAttribute("aria-hidden", "true")

      return true
    }

    return false
  }

  /**
   * Observes DOM changes and adds data-nosnippet when OneTrust banner appears
   */
  const observeBannerInjection = () => {
    // Try immediately first (in case banner loads quickly)
    if (addNoSnippetToBanner()) {
      return
    }

    // Set up MutationObserver to watch for banner injection
    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
          // Check if the OneTrust banner was added
          if (addNoSnippetToBanner()) {
            // Success! Disconnect observer to stop watching
            observer.disconnect()
            return
          }
        }
      }
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true
    })

    setTimeout(() => {
      observer.disconnect()
    }, 10000)
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeBannerInjection)
  } else {
    observeBannerInjection()
  }
})
